import { Pipe, PipeTransform } from '@angular/core';
import { flow, partial } from 'lodash-es';

const UnitOfMeasures = ['CS', 'EA', 'PA', 'DR', 'PZ', 'BG', 'CO', 'TO'] as const;

export type UnitOfMeasure = typeof UnitOfMeasures[number];

type UnitOfMeasureMap = { [key in UnitOfMeasure]: string; };

const UNIT_OF_MEASURE_MAP: UnitOfMeasureMap = {
  'CS': 'Case',
  'EA': 'Each',
  'PA': 'Pallet',
  'DR': 'Drum',
  'PZ': 'Pail',
  'BG': 'Bag',
  'CO': 'Combo',
  'TO': 'Tote'
};

function uomToString(unitOfMeasure: string) {
  return UNIT_OF_MEASURE_MAP[unitOfMeasure];
}

function quantifyUom(quantity: number, formattedUom: string) {
  return Math.abs(quantity) === 1 ? formattedUom : formattedUom + 's';
}

export function formatUnitOfMeasure(unitOfMeasure: string, quantity: number) {
  const quantify = partial(quantifyUom, quantity || 0);
  const pipeline = flow(uomToString, quantify);

  return pipeline(unitOfMeasure);
}

@Pipe({ name: 'uom' })
export class UnitOfMeasurePipe implements PipeTransform {
  transform(unitOfMeasure: string, quantity: number): string {
    return formatUnitOfMeasure(unitOfMeasure, quantity);
  }
}
